import { Grid2X2, List, Trash2 } from "lucide-react";
import { wishlistSortOptions } from "@/theme2/data/wishlist";
import WishlistFilters from "@/theme2/components/wishlist/WishlistFilters";

export default function WishlistToolbar({
  sort,
  onSortChange,
  filter,
  onFilterChange,
  view,
  onViewChange,
  onClear,
  disabled,
}) {
  return (
    <div className="sticky top-4 z-20 rounded-[1.5rem] border border-border/60 bg-white/85 p-4 shadow-xl shadow-black/5 backdrop-blur-xl">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <WishlistFilters value={filter} onChange={onFilterChange} />

        <div className="flex flex-wrap items-center gap-2">
          <select
            value={sort}
            onChange={(event) => onSortChange(event.target.value)}
            className="rounded-full border border-border bg-white px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          >
            {wishlistSortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          <button
            type="button"
            onClick={() => onViewChange("grid")}
            className={`inline-flex size-10 items-center justify-center rounded-full border ${
              view === "grid" ? "bg-foreground text-background" : "bg-white"
            }`}
            aria-label="Grid view"
          >
            <Grid2X2 className="size-4" />
          </button>

          <button
            type="button"
            onClick={() => onViewChange("list")}
            className={`inline-flex size-10 items-center justify-center rounded-full border ${
              view === "list" ? "bg-foreground text-background" : "bg-white"
            }`}
            aria-label="List view"
          >
            <List className="size-4" />
          </button>

          <button
            type="button"
            onClick={onClear}
            disabled={disabled}
            className="inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-sm font-medium text-muted-foreground transition hover:text-red-600 disabled:opacity-40"
          >
            <Trash2 className="size-4" />
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
